import { NavLink, Outlet } from "react-router";

import { cn } from "@/ui/cn";
import { PageHeader } from "@/ui/PageHeader";

const TABS = [
  { to: "/knowledge/sources", label: "Sources" },
  { to: "/knowledge/types", label: "Types" },
  { to: "/knowledge/code-standard", label: "Code standard" },
  { to: "/knowledge/score", label: "Score" },
] as const;

/**
 * What the organization knows about its own take-offs (ADR-0014): the past work it has
 * added, the types learned from it, and how its codes are built. Each tab is its own
 * route.
 */
export function KnowledgeScreen() {
  return (
    <main className="mx-auto w-full max-w-6xl px-4 py-8 lg:px-8">
      <PageHeader
        title="Knowledge"
        description="How your company does take-offs, learned from its past work."
      />
      <nav aria-label="Knowledge" className="mt-6 flex gap-1 border-b border-line">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              cn(
                "-mb-px border-b-2 px-3 py-2 text-sm no-underline",
                isActive
                  ? "border-accent font-medium text-ink"
                  : "border-transparent text-muted hover:text-ink",
              )
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <div className="mt-6">
        <Outlet />
      </div>
    </main>
  );
}
